import { DtoCoordenadas } from "./DtoCoordenadas"
import { DtoEstado } from "./DtoEstado";

export class DtoFotos {
    Coordenadas: DtoCoordenadas = new DtoCoordenadas();
    Estado: DtoEstado = new DtoEstado();
    Fecha: Date = new Date();
    Ruta: string = '';
    img: string = '';
}